import { html } from "lit";
import { getDummyText } from "../../../../utils";

export const dummyProduct = {
    productImageUrl: "mock-assets/images/trulaser-station-7000.jpg",
    productName: "TruLaser Station 7000",
    productDesc: "Product Description " + getDummyText(100),
    linkUrl: "#",
    linkText: "Zum Produkt",
    eyecatcher: "",
};

export const dummyProducts = [
    {
        ...dummyProduct,
        productImageUrl: "./mock-assets/images/TruLaser-highlight.png",
        productName: "TruMicro Serie 7000",
        eyecatcher: ".NEW",
    },
    {
        ...dummyProduct,
        productImageUrl: "./mock-assets/images/TruLaser-highlight.png",
        productName: "TruMicro Series 5000",
    },
    {
        ...dummyProduct,
        productImageUrl: "./mock-assets/images/TruLaser-highlight.png",
        productName: "TruDisk",
        eyecatcher: ".NEW",
    },
    {
        ...dummyProduct,
        productImageUrl: "./mock-assets/images/TruLaser-highlight.png",
        productName: "TruMark Station 1000",
        eyecatcher: ".NEW",
    },
    {
        ...dummyProduct,
        productImageUrl: "./mock-assets/images/TruLaser-highlight.png",
        productName: "TruMark Station 5000",
    },
    {
        ...dummyProduct,
        productImageUrl: "./mock-assets/images/TruLaser-highlight.png",
        productName: "TruLaser Tube 3000 fiber",
        eyecatcher: ".NEW",
    },
    {
        ...dummyProduct,
        productImageUrl: "./mock-assets/images/TruLaser-highlight.png",
        productName: "TruLaser Cell 3000",
        eyecatcher: ".NEW",
    },
    {
        ...dummyProduct,
        productImageUrl: "mock-assets/images/trulaser-station-7000.jpg",
        productName: "TruLaser Cell 7040",
    },
];

export const TeaserProductTileTemplate = ({
    productImageUrl = "",
    productName = "",
    productDesc = "",
    linkText = "",
    linkUrl = "",
    eyecatcher = "",
}) => html`
    <ux-iws-teaser-product-tile
        product-image-url="${productImageUrl}"
        product-name="${productName}"
        product-desc="${productDesc}"
        eyecatcher="${eyecatcher}"
        ><a
            href="${linkUrl}"
            class="ux-text-link ux-iws-teaser-product-tile__link"
            >${linkText}<ux-icon name="arrow-small-right"
        /></a>
    </ux-iws-teaser-product-tile>
`;

export const TeaserProductTileListTemplate = () => html`
    <div class="ux-iws-teaser-product-tile-grid">
        ${dummyProducts.map((tile) => TeaserProductTileTemplate(tile))}
    </div>
`;
